export default __webpack_public_path__ + "assets/images/ff65e9779980bc60c90f7aae7c7d30dc.png";